import { GlobalClassKeys } from 'assets/jss/common-styles';
import BoxDrawer from 'components/BoxDrawer';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import { MemberSuggestionDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import MemberAutoComplete, { MemberAutoCompleteSearchParams } from 'views/Member/Components/MemberAutoComplete';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    members: MemberSuggestionDto[];
    canSave: boolean;
}

interface IProps {
    title?: string;
    subtitle?: string;
    buttonText?: string;
    onCustomGetMembers?: (p: MemberAutoCompleteSearchParams) => Promise<MemberSuggestionDto[]>;
    onClose: (members: string[]) => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class MemberSelectionDrawer extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            members: null,
            canSave: false
        };
    }

    ///
    public render() {
        const { buttonText, onClose, title, subtitle } = this.props;
        return (
            <BoxDrawer
                open
                title={title || "Selecionar"}
                subtitle={subtitle}
                onClose={() => { onClose(null); }}
            >
                <MuiPaper dense elevation={0}>

                    <MemberAutoComplete
                        autoFocus
                        overModal
                        label={this.props.t<string>("Views.Member.Dialogs.MemberSelectionDrawer.Placeholder")}
                        error={this.state.members != null && this.state.members.length == 0}
                        multiple={true}
                        selectedItems={this.state.members}
                        margin="normal"
                        onCustomGetMembers={this.props.onCustomGetMembers}
                        onChange={
                            (members) => {
                                this.setState({
                                    members,
                                    canSave: members.length > 0
                                });
                            }
                        }
                    />

                    <div className={GlobalClassKeys.textCenter}>
                        <MuiRegularButton
                            fullWidth
                            disabled={!this.state.canSave}
                            color="secondary"
                            onClick={
                                () => {
                                    onClose(
                                        this.state.members == null || this.state.members.length == 0
                                            ? null
                                            : this.state.members.map((v) => v.key)
                                    );
                                }}
                        >
                            <span>{buttonText || this.props.t("Common.Buttons.OkText")}</span>
                        </MuiRegularButton>
                    </div>

                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withTranslation()(MemberSelectionDrawer);